module.exports = __webpack_public_path__ + "static/media/banner.31c0ccbb.png";